import { Box, Heading, VStack } from '@chakra-ui/react'
import { resolvePaywallIntent } from '@src/components/sco/Conversion/intent'
import { MembershipPricingPage } from '@src/components/sco/Pricing/MembershipPricingPage'
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'

import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default function Page() {
  const activeContent = useActiveContentContext()
  const { getBreakpointValue } = useBreakpointContext()
  const plansIntent = resolvePaywallIntent('default')

  useUniversalEffect(() => {
    activeContent.setSiteSection('signup.plans')
  })

  return (
    <>
      <ScoSiteNavBar />
      <Box
        background={'colorPalette.panel'}
        minHeight={'93vh'}
        paddingBottom={getBreakpointValue([12, 12, 14, 14, 20])}
        paddingTop={getBreakpointValue([12, 12, 14, 14, 20])}
        width={'full'}
      >
        <Box marginX={'auto'} maxWidth={'container.xl'}>
          <VStack
            align={'center'}
            gap={getBreakpointValue([2, 2, 4])}
            marginBottom={getBreakpointValue([6, 6, 8, 10, 12])}
            paddingX={getBreakpointValue([4, 6, 8])}
            textAlign={'center'}
            width={'full'}
          >
            <Heading as={'h1'} size={getBreakpointValue(['2xl', '3xl', '4xl'])} textAlign={'center'}>
              Membership Plans
            </Heading>
            {/*<Text*/}
            {/*  color={'fg.muted'}*/}
            {/*  fontSize={getBreakpointValue(['md', 'lg', 'lg', 'xl'])}*/}
            {/*  maxWidth={'2xl'}*/}
            {/*  textWrap={'balance'}*/}
            {/*>*/}
            {/*  {plansIntent.supporting}*/}
            {/*</Text>*/}
          </VStack>
          <Box paddingX={[4, 6, 8]}>
            <Box marginX={'auto'} maxWidth={'5xl'} width={'full'}>
              <MembershipPricingPage showFree align={'center'} showHero={false} />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
